export default "__VITE_ASSET__CYifEfJE__"